var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseHeader',{attrs:{"title":_vm.$t('page_not_found').toString()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }